import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, Form, Input, InputNumber, Radio, Select } from "antd";
import { jsonDataStatusSimulation } from "../../../../types/initStore/initSimulation";
import { useFieldsProviderSimulation } from "../hooks/useFieldsProviderSimulation";
import { teamAreasByFormHoursAdd } from "../../../../types/initStore/initUser";
import { typeForm } from "../../../../types/forms";


export const FormProviderSimulation = ({ updateProject }) => {
    const {
        simulation: {
            formProviders,
            selectTypeForm,
            loadings: { buttonProviderLoading },
        },
    } = useSelector((state) => state);
    const dispath = useDispatch();

    const { form, onFinish, checkHours, setCheckHours } = useFieldsProviderSimulation(dispath, formProviders);

    return (
        <Form form={form} onFinish={(props) => {
            onFinish(props, updateProject);
        }} name="platform_project" layout="vertical" className="w-full">
            <div>
                <div className="flex gap-4">
                    <Form.Item
                        className="w-full"
                        name={["name"]}
                        label="Nombre"
                        rules={[
                            {
                                required: true,
                                message: "Nombre",
                            },
                        ]}
                    >
                        <Input size="large" className="w-full" />
                    </Form.Item>
                    <Form.Item name={["currency"]} label="Moneda">
                        <Radio.Group className="flex">
                            <Radio.Button className="h-10" value="MXN">
                                <span className="flex items-center h-full">MXN</span>
                            </Radio.Button>
                            <Radio.Button className="h-10" value="USD">
                                <span className="flex items-center h-full">USD</span>
                            </Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                </div>

                <div>
                    <Form.Item name={["link"]} label="Enlace">
                        <Input size="large" className="w-full" />
                    </Form.Item>
                </div>
                <div className="grid gap-4 grid-cols-2">
                    <Form.Item
                        name={["status"]}
                        label="Estado"
                        rules={[
                            {
                                required: true,
                                message: "selecciona un estado",
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="selecciona un estatus"
                            style={{
                                width: "100%",
                            }}
                        >
                            {Object.values(jsonDataStatusSimulation)
                                .map((item) => item.name)
                                .map((statu) => (
                                    <Select.Option key={`${statu}-status`} value={statu}>
                                        {statu}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={["area"]}
                        label="Area"
                        rules={[
                            {
                                required: true,
                                message: "selecciona una area",
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="selecciona un area"
                            style={{
                                width: "100%",
                            }}
                        >
                            {teamAreasByFormHoursAdd().map((area) => (
                                <Select.Option key={`${area}-areas`} value={area}>
                                    {area}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </div>
            </div>
            <div>
                <Checkbox
                    className="mb-4"
                    onChange={(e) => {
                        setCheckHours(e.target.checked);
                    }}
                >
                    <span>Horas para la calculadora</span>
                </Checkbox>
                {checkHours ? (
                    <div className="grid gap-4 grid-cols-2 -mb-4">
                        <Form.Item name={["outsourceHours"]} label="Hrs. a Tercerizar">
                            <InputNumber size="large" min={0} className="w-full" />
                        </Form.Item>
                        <Form.Item name={["budget"]} label="Cotización Proveedor">
                            <InputNumber size="large" min={0} className="w-full" />
                        </Form.Item>
                    </div>
                ) : (
                    <Form.Item name={["price"]} label="Precio">
                        <InputNumber size="large" min={0} className="w-full" />
                    </Form.Item>
                )}
            </div>
            <Form.Item className="w-full flex justify-end m-0 mt-4">
                <Button type="primary" htmlType="submit" loading={buttonProviderLoading} className="bg-primaryTwo hover:bg-primaryTwoHover">
                    {selectTypeForm === typeForm.create ? "Crear" : "Editar"}
                </Button>
            </Form.Item>
        </Form>
    );
};
